<template>
  <div>
    <div style="text-align: left">
      <div class="searchbarcls">
        <el-form :model="searchForm">
          所属企业:<el-input size="small" v-model="searchForm.tenantPid" style="width: 200px;"></el-input>
          用户姓名:<el-input size="small" v-model="searchForm.userName" style="width: 200px;"></el-input>
          用户帐号:<el-input size="small" v-model="searchForm.userAccount" style="width: 200px;"></el-input>
          &nbsp;<el-button type="primary" icon="el-icon-search" size="small" @click="loadTableData()">查询</el-button>
        </el-form>
      </div>
      <div style="padding: 2px;">
        <PermissionMethodToolbar :url="url" id="toolbar" @showAddDialog="showAddDialog"></PermissionMethodToolbar>
      </div>
    </div>
    <el-table ref="myElTable" background="true" :data="tableData" :height="clientHeight-otherHeight" @row-click="tableTrClick" border style="width: 100%;">
      <el-table-column type="selection" width="42" />
      <el-table-column type="index" label="序号" fixed="left" width="50">
      </el-table-column>
      <el-table-column prop="tenantName" label="所属企业" width="330">
      </el-table-column>
      <el-table-column prop="userName" label="用户姓名" width="130">
      </el-table-column>
      <el-table-column prop="userAccount" label="用户帐号" width="130">
      </el-table-column>
      <el-table-column prop="roleName" label="拥有角色">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <PermissionMethodRow :url="url" id="rowtoolbar" @showUpdateDialog="showUpdateDialog(scope.row)" @deleteUser="deleteUser(scope.row)"></PermissionMethodRow>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.currPage" :page-sizes="[20, 30, 50]" :page-size="20"
                   layout="total,jumper, prev, pager, next,sizes" :total="searchForm.dataTotal">
    </el-pagination>
    <!--添加div-->
    <el-dialog title="新增人员信息" size="35%" :visible.sync="drawer" :wrapperClosable="false" direction="rtl">
      <AddUserWindow ref="addUserWindow" :closeWindow="closeWindow"></AddUserWindow>
    </el-dialog>
    <!--修改div-->
    <el-dialog title="修改人员信息" size="35%" :visible.sync="udrawer" :wrapperClosable="false" direction="rtl">
      <UPdateUserWindow ref="updateUserWindow" :userData="userData" :closeWindow="closeWindow"></UPdateUserWindow>
    </el-dialog>
  </div>
</template>
<script>
import AddUserWindow from '@/views/system/user/AddUserWindow.vue';
import UPdateUserWindow from '@/views/system/user/UpdateUserWindow.vue';
import { appjs } from "@/utiljs/apputil";
export default {
          components: {
            AddUserWindow,
            UPdateUserWindow
        },
  props: {
    clientHeight: {
      type: Number
    },
    url: {
      type: String
    }
  },
  data () {
    return {
      otherHeight: 210,
      drawer: false,
      udrawer: false,
      userData: {},
      searchForm: {
        dataTotal: 0,
        pageSize: 20,
        currPage: 1,
        tenantPid: '',
        userName: '',
        userAccount: ''
      },
      tableData: []
    }
  },
  created () {
    this.loadTableData(1);
  },
  methods: {
    //提供给子组件调用的方法
    closeWindow (msg) {
      this.drawer = false;
      this.udrawer = false;
      if (msg) {
        this.loadTableData(1);
        appjs.showSuccessMsg(msg, 2000, 50);
      }
    },
    loadTableData () {
      let load = appjs.loading();
      let _self = this;
      let params = this.searchForm;
      appjs.httpRequest('user/queryUser', params).then(
        (data) => {
          if (data.retCode && data.retCode != "ok") {
            appjs.showErrorMsg(data.retMsg)
          } else {
            _self.searchForm.dataTotal = data.totalRowNum;
            _self.tableData = data.dataList;
            this.$refs.myElTable.bodyWrapper.scrollTop = 0;
          }
          appjs.unloading(load);
        }
      ).catch(
        (errmsg) => {
          appjs.showErrorMsg(errmsg)
          appjs.unloading(load);
        });
    },
    deleteUser (rowdata) {
      let _self = this;
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        let load = appjs.loading('数据删除中');
        appjs.httpRequest('user/deleteUser', { userPid: rowdata.userPid }).then(
          (data) => {
            if (data.retCode && data.retCode != "ok") {
              appjs.unloading(load);
              appjs.showErrorMsg(data.retMsg)
            } else {
              appjs.unloading(load);
              appjs.showSuccessMsg(data.retMsg)
              _self.loadTableData();
            }
          }
        ).catch(
          (errmsg) => {
            appjs.showErrorMsg(errmsg)
            appjs.unloading(load);
          });
      });
    },
    //表格行点击
    tableTrClick (row, column, event) {
      this.$refs.myElTable.clearSelection();
      this.$refs.myElTable.toggleRowSelection(row);
    },
    //每页显示行数改变
    handleSizeChange (val) {
      this.searchForm.pageSize = val;
      this.loadTableData();
    },
    //分页栏
    handleCurrentChange (val) {
      this.searchForm.currPage = val;
      this.loadTableData();
    },
    deleteSelData () {
      let idx = 0, selIdx;
      if (this.$refs.myElTable.store.states.selection.length > 1) {
        appjs.showWarningNotify('一次只能删除一条')
        return;
      }
      this.tableData.forEach(item => {
        this.$refs.myElTable.store.states.selection.forEach(sitem => {
          if (item.seq_num == sitem.seq_num) {
            selIdx = idx;
          }
        })
        idx++;
      })
    },
    showAddDialog () {
      this.drawer = true;
      if (this.$refs['addUserWindow']) {
        this.$refs['addUserWindow'].resertForm();
      }
    },
    showUpdateDialog (data) {
      this.userData = JSON.parse(JSON.stringify(data));
      let _self = this;
      _self.udrawer = true;
      this.$nextTick(() => {
        if (_self.$refs['updateUserWindow']) {
          _self.$refs['updateUserWindow'].resertForm();
        }
      });
    },
    getTableSelData () {
      //console.log(JSON.stringify(this.$refs.myElTable.store.states.selection));
      this.$refs.myElTable.store.states.selection.forEach(item => {
        for (const key in item) {
        }
      })
    }
  }
}
</script>
<style>
.custom-dialog .el-dialog__body {
  /*height: calc(60vh - 10px);  设置具体高度 */
  height: 600px;
  overflow-y: auto; /* 如果内容超出，显示滚动条 */
}
</style>
